import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Lock } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const ChangePasswordDialog = ({ open, onOpenChange, mustChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Update failed");
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onOpenChange={mustChange ? () => {} : onOpenChange}>
      <DialogContent className="max-w-md rounded-none border-[#E2E2E5]" data-testid="change-password-dialog">
        <DialogHeader className="border-b border-[#E2E2E5] pb-3">
          <DialogTitle className="font-display font-black tracking-tight text-2xl flex items-center gap-2">
            <Lock size={20} className="text-[#006CFF]" />
            {mustChange ? "Set a new password" : "Change password"}
          </DialogTitle>
          <DialogDescription className="sr-only">Update your account password.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 py-2">
          {mustChange && (
            <div className="text-xs px-3 py-2 bg-[#FF990014] text-[#C97000] border border-[#FF990066]">
              Welcome! For security, please change your temporary password before continuing.
            </div>
          )}
          <div>
            <Label className="text-xs font-mono uppercase tracking-wider text-[#5C5E66]">Current Password</Label>
            <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="rounded-none mt-1 font-mono" required />
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-wider text-[#5C5E66]">New Password</Label>
            <Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="rounded-none mt-1 font-mono" minLength={8} required />
            <div className="text-[10px] font-mono text-[#5C5E66] mt-1">Minimum 8 characters</div>
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-wider text-[#5C5E66]">Confirm New Password</Label>
            <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-none mt-1 font-mono" required />
          </div>
          <DialogFooter className="border-t border-[#E2E2E5] pt-3 gap-2">
            {!mustChange && <Button type="button" variant="outline" className="rounded-none" onClick={() => onOpenChange(false)}>Cancel</Button>}
            <Button type="submit" data-testid="cp-submit-btn" disabled={submitting} className="bg-[#006CFF] hover:bg-[#0052CC] text-white rounded-none">
              {submitting ? "UPDATING..." : "Update Password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
